import * as yup from 'yup';
import { fieldValidationMessages } from 'app/constants';
import {
  CollaboratorPermission,
  InviteCollaboratorsPayload,
  InviteeUserGuidWithType,
} from 'types/collaborator.types';
import { InviteCollaboratorValidations } from 'types/profile';
import { AddCollaboratorsFormData } from './types';

export const toInviteCollaboratorsPayload = ({
  collaborators,
  emailMessage,
}: AddCollaboratorsFormData) => {
  const { inviteeEmails, inviteeUserGuids } = collaborators.reduce(
    (collabs, { subject, displayName, inviteType }) => {
      if (subject) {
        collabs.inviteeUserGuids?.push({
          guid: subject,
          inviteType,
        });
      } else {
        collabs.inviteeEmails?.push(displayName);
      }

      return collabs;
    },
    {
      inviteeUserGuids: [] as InviteeUserGuidWithType[],
      inviteeEmails: [] as string[],
    }
  );

  return {
    permission: CollaboratorPermission.ADMIN,
    ...(inviteeUserGuids.length > 0 ? { inviteeUserGuids } : null),
    ...(inviteeEmails.length > 0 ? { inviteeEmails } : null),
    ...(emailMessage.length > 0 ? { message: emailMessage } : null),
  } as InviteCollaboratorsPayload;
};

export const getValidationSchema = (
  validations?: InviteCollaboratorValidations
) => {
  const { inviteeEmail, message } = validations?.properties || {};
  return yup.object().shape(
    {
      searchText: yup
        .string()
        .email(fieldValidationMessages.EMAIL)
        .max(
          inviteeEmail?.maxLength || 255,
          fieldValidationMessages.MAX_CHAR(inviteeEmail?.maxLength || 255)
        ),
      collaborators: yup.array().of(
        yup.object().when('inviteeEmail', {
          is: (email?: string) => !email,
          then: yup.object().typeError(fieldValidationMessages.REQUIRED),
          otherwise: yup.object().nullable(),
        })
      ),
      emailMessage: yup
        .string()
        .max(
          message?.maxLength || 255,
          fieldValidationMessages.MAX_CHAR(message?.maxLength || 255)
        ),
    },
    [['collaborator', 'inviteeEmail']]
  );
};

export const isValidEmail = (email: string) =>
  yup
    .string()
    .email(fieldValidationMessages.EMAIL)
    .max(255, fieldValidationMessages.MAX_CHAR(255))
    .isValidSync(email);
